// this is not capitalized because backend is expecting same as this ENUM

export const STATUS = {
  PENDING: "Pending",
  ON_GOING: "On Going",
  SOLVED: "Solved",
  CLOSED: "Closed",
};
